<template>
  <card titulo="Tabelionato">

    <consulta :columns="columns" ref="tabela" :process="process" classe="tbl-consulta">

      <template #row="{ row }">

        <tr>
          <td class="text-truncate">
            <router-link :to="{ name: 'protocolo', params: { id: row.id } }" class="mb-1 pointer" target="_blank" @click.native="$event.stopImmediatePropagation()">
              {{ nomearProtocolo(row.dominio, row.tipoProtocolo, row.codigo) }}
            </router-link>
          </td>
          <td>{{ row.tipoServico }}</td>
          <td>{{ row.etapa }}</td>
          <td style="min-width: 120px">{{ row.cadastro | data }}</td>
          <td style="min-width: 120px">{{ row.vencimento | data }}</td>
          <td style="min-width: 120px">{{ row.registro | data }}</td>
        </tr>

      </template>

    </consulta>

  </card>
</template>

<script>
  import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
  import FrontBusiness from "@/business/FrontBusiness";
  import Consulta from "@/components/Consultas/Consulta";
  import Card from "@/components/Layout/components/Card.vue";

  export default {

    name: "Tabelionato",
    components: { Consulta, Card },
    props: {
      ficha: Object
    },

    computed: {
      columns() {
        return [
          { label: 'Código', field: 'p.codigo' },
          { label: 'Serviço', field: 'p.tiposervico' },
          { label: 'Etapa', field: 'p.etapa' },
          { label: 'Cadastro', field: 'p.cadastro' },
          { label: 'Vencimento Lavratura', field: 'p.vencimento' },
          { label: 'Lavratura', field: 'p.registro' },
        ];
      },
    },

    async mounted() {
      await this.$refs?.tabela?.load();
    },

    methods: {

      nomearProtocolo: FrontBusiness.nomearProtocolo,

      async process(sort_by, sort_dir, page_length, page_number) {
        let result = await IndicadorRealBusiness.buscarAtosTabelionato(this.ficha.id);
        return { rows: result, total: result.length };
      },

    }
  }
</script>

<style lang="scss">
  .tbl-consulta {
    .modal-body {
      padding: 0;
    }
  }
</style>
